/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEyeOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.47.47a.75.75 0 011.06 0l8.878 8.877.004.005 4.236 4.236.005.004 8.877 8.878a.75.75 0 11-1.06 1.06l-4.611-4.61a10.82 10.82 0 01-5.847 1.83H12c-4.435 0-7.693-2.953-9.579-5.277a20.78 20.78 0 01-1.55-2.186 16.685 16.685 0 01-.53-.93l-.008-.014-.003-.005v-.002L1 12l-.67.335a.75.75 0 01.01-.69 19.2 19.2 0 014.597-5.647L.47 1.53a.75.75 0 010-1.06zm5.532 6.593a17.699 17.699 0 00-4.147 4.94 19.275 19.275 0 001.731 2.524c1.798 2.216 4.668 4.72 8.408 4.723a9.32 9.32 0 004.78-1.415l-2.692-2.692a3.75 3.75 0 01-5.225-5.225L6.002 7.063zm3.943 3.943a2.241 2.241 0 00-.27 1.03 2.25 2.25 0 003.32 2.019l-3.05-3.05zm12.217.978c-1.998-3.742-6.194-7.69-12.105-7.236a.75.75 0 01-.114-1.496c6.918-.53 11.651 4.246 13.727 8.384a.75.75 0 01.009.655c-.584 1.243-1.069 1.955-2.112 3.161a.75.75 0 11-1.134-.98c.87-1.008 1.284-1.593 1.729-2.488z'
        />
      </g>
      <defs>
        <clipPath id='eye-off_svg__clip0_126_10382'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgEyeOff;
